import i18next from 'i18next';
import { ReactComponent as PendingIcon } from 'assets/icons/pending.svg';
import { ReactComponent as ProcessingIcon } from 'assets/icons/processing.svg';
import { ReactComponent as HoldIcon } from 'assets/icons/hold.svg';

/**
 * Resource invitation lifecycle states. Backend string values —
 * keep lowercase, must match API responses.
 */
export const RESOURCE_STATUSES = {
  invited: 'invited',
  engaged: 'engaged',
  scheduled: 'scheduled',
};

/**
 * Display-ready options for status filter dropdowns and badges.
 * Labels are resolved via i18next at module load time — translations
 * must be initialised before this module is imported (handled by the
 * i18n provider at the top of the provider stack).
 */
export const RESOURCE_STATUSES_OPTIONS = [
  {
    label: i18next.t('tables:invited'),
    value: RESOURCE_STATUSES.invited,
    icon: HoldIcon,
    allowEditOrder: false,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:engaged'),
    value: RESOURCE_STATUSES.engaged,
    icon: PendingIcon,
    allowEditOrder: false,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:scheduled'),
    value: RESOURCE_STATUSES.scheduled,
    icon: ProcessingIcon,
    allowEditOrder: false,
    enabledForNonSponsors: false,
  },
];
